import { CollectingCompanyTableItem } from '../interfaces'

export const toTableRowItems = (items: CollectingCompanyTableItem[]) =>
  items.map((item: CollectingCompanyTableItem) => ({
    id: item.id,
    name: item.name ?? '',
    email: item.email ?? '',
    contactNumber: item.contactNumber ?? '',
    contractNumber: item.contractNumber ?? '',
    tradeRegisterNumber: item.tradeRegisterNumber ?? '',
    cif: item.cif ?? '',
    headquarter: item.headquarter ?? '',
    county: item.county ?? '',
    iban: item.iban ?? '',
    bank: item.bank ?? '',
    categories: item.categories ?? [],
    locationNumber: item.locationNumber ?? 0
  }))
